import { useRouteError } from "react-router-dom";

export function RouteErrorFallback() {
  const error = useRouteError() as Error | null;

  console.error(error);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-lg">
        {/* Icon */}
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full">
          <span className="text-2xl">⚠️</span>
        </div>

        {/* Title */}
        <h2 className="text-xl font-semibold text-gray-900">
          Something went wrong
        </h2>

        {/* Description */}
        <p className="mt-2 text-sm text-gray-600">
          There are issues with interner connection or the server. Please check
          your connection and try again. If the problem persists, contact
          support.
        </p>

        {/* Actions */}
        <div className="mt-6 flex flex-col gap-3">
          <button
            className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      </div>
    </div>
  );
}
